import { render } from "./LoadTestPage.vue?vue&type=template&id=4af1ed7a"
import script from "./LoadTestPage.vue?vue&type=script&lang=js"
export * from "./LoadTestPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__